import { UserGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useUser = <TData = UserGetResponseType,>(
  userId: number,
  options?: ApiV2QueryOptions<TData>,
): UseQueryResult<TData> => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [user?.uid, business?.id, ServerStateKeys.SellarUser, userId],

    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `users/${userId}`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
